function imageCheck({
  file,
  setMessage,
  setAttachmentDetails,
  setAttachmentObject,
}: any) {
  const img = new Image();
  const objectUrl = URL.createObjectURL(file);

  img.onload = function () {
    const { width, height } = img;

    // if (width <= 800 && height <= 400) {
    if (file.size <= 1024 * 1024) {
      const reader = new FileReader();
      reader.onload = () => {
        if (reader.result) {
          setAttachmentDetails({
            name: file?.name,
            base64URL: reader.result.toString(),
          });
        }
      };
      reader.readAsDataURL(file);
      setMessage("");
      setAttachmentObject(file);
    } else {
      setAttachmentDetails(null);
      setAttachmentObject({});
      setMessage("File size exceeds the maximum limit of 1 MB.");
    }

    URL.revokeObjectURL(objectUrl);
  };

  img.src = objectUrl;
}

function onlyPDF({
  file,
  setAttachmentDetails,
  setMessage,
  setAttachmentObject,
}: any) {
  const fileSizeInMB = file.size / (1024 * 1024);
  if (fileSizeInMB <= 50) {
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.result) {
        setAttachmentDetails({
          name: file?.name,
          base64URL: reader.result.toString(),
        });
      }
    };
    reader.readAsDataURL(file);
    setMessage("");
    setAttachmentObject(file);
  } else {
    setAttachmentDetails(null);
    setAttachmentObject({});
    setMessage("The file size should be less than or equal to 50MB.");
  }
}

export { imageCheck, onlyPDF };
